// ** React Imports
import { ReactNode, useEffect } from 'react'

// ** Hooks Import
import Spinner from 'src/@core/components/spinner'
import Error500 from 'src/pages/500'
import { useUser } from '@auth0/nextjs-auth0'
import { useMeLazyQuery } from 'src/generated/graphql'

interface MeGuardProps {
  children: ReactNode
}

/** Ensures that the graphql/me endpoint is called. This will create a user in the database if
 * one does not already exist
 */
const MeGuard = (props: MeGuardProps) => {
  const { children } = props

  const { user } = useUser()
  const [meQuery, { data, error, called }] = useMeLazyQuery()

  useEffect(() => {
    if (user && !called) {
      meQuery()
    }
  }, [called, meQuery, user])

  if (user && data?.me) {
    return <>{children}</>
  } else if (error) {
    return <Error500 />
  } else {
    return <Spinner text='Getting user information...' />
  }
}

export default MeGuard
